
require('parallax/deploy/parallax')

class ParallaxClass {
  constructor () {
    this.options = {
      calibrateX: true,
      calibrateY: true,
      invertX: false,
      invertY: true,
      limitX: false,
      limitY: 0,
      scalarX: 2,
      scalarY: 8,
      frictionX: 0.2,
      frictionY: 0.8
    }
  }

  addToPage (page) {
    if (this.parallax !== undefined) {
      // if we're returning to the scene, just enable the existing parallax...
      this.parallax.enable()
    } else {
      // ... else set up the parallax object
      const _parent = document.getElementById(page)
      const _scene = _parent.getElementsByClassName('scene')[0]

      let _parallax = new window.Parallax(_scene, this.options)

      this.parallax = _parallax
      this.parallax.enable()
    }
  }

  disable () {
    if (this.parallax !== undefined) {
      this.parallax.disable()
    }
  }
}

export { ParallaxClass }



// WEBPACK FOOTER //
// ./src/classes/ParallaxClass.js